// {signature} {pubKey}

const bscript = require('../../script')

function isCompressedCanonicalPubKey (pubKey) {
  return bscript.isCanonicalPubKey(pubKey) && pubKey.length === 33
}

function check (script) {
  const chunks = bscript.decompile(script)

  return chunks.length === 2 &&
    bscript.isCanonicalScriptSignature(chunks[0]) &&
    isCompressedCanonicalPubKey(chunks[1])
}
check.toJSON = function () { return 'witnessPubKeyHash input' }

module.exports = { check }



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/witnesspubkeyhash/input.js
// module id = 391
// module chunks = 0